import { ReactNode } from "react";

import { SplitFactoryWithConfig as BitSplitFactory } from "@moodys/mdc-frontend.services.split";

import { split } from "@moodys/federated";
import { config } from "config";
import { ANONYMOUS_DEFAULT } from "hooks/useUserInfo/useUserInfo";
import { SPLIT_TEST_FEATURES } from "services/split/split.constants";

import { LayoutContextProvider } from "../Layout";

export const SplitFactoryLayoutContext = ({
  children,
}: {
  children: ReactNode;
}) => {
  return (
    // Necessary for squads still using Split from Bit
    // BitSplitFactory will be removed once all squads are migrated to NFE Split [MDCPT-52817]
    <BitSplitFactory
      {...config.SPLIT_SDK}
      userKey={ANONYMOUS_DEFAULT}
      features={SPLIT_TEST_FEATURES}
    >
      <split.SplitFactoryWithConfig
        {...config.SPLIT_SDK}
        userKey={ANONYMOUS_DEFAULT}
        features={SPLIT_TEST_FEATURES}
      >
        <LayoutContextProvider>{children}</LayoutContextProvider>
      </split.SplitFactoryWithConfig>
    </BitSplitFactory>
  );
};
